/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AddPaymentRequest } from '../model';
// @ts-ignore
import { AdminSubscriptionDetailResponse } from '../model';
// @ts-ignore
import { CreateSubscriptionRequest } from '../model';
// @ts-ignore
import { DietaryTargetsRequest } from '../model';
// @ts-ignore
import { PagedResponsePausedSubscriptionResponse } from '../model';
// @ts-ignore
import { PauseSubscriptionRequest } from '../model';
// @ts-ignore
import { SubscriptionDetailResponse } from '../model';
// @ts-ignore
import { UpdateSubscriptionActionRequest } from '../model';
// @ts-ignore
import { UpdateSubscriptionRequest } from '../model';
/**
 * AdminSubscriptionControllerApi - axios parameter creator
 * @export
 */
export const AdminSubscriptionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} subscriptionId 
         * @param {AddPaymentRequest} addPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSubscriptionPayment: async (subscriptionId: string, addPaymentRequest: AddPaymentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('addSubscriptionPayment', 'subscriptionId', subscriptionId)
            // verify required parameter 'addPaymentRequest' is not null or undefined
            assertParamExists('addSubscriptionPayment', 'addPaymentRequest', addPaymentRequest)
            const localVarPath = `/admin/subscriptions/{subscriptionId}/payments`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription: async (subscriptionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('cancelSubscription', 'subscriptionId', subscriptionId)
            const localVarPath = `/admin/subscriptions/{subscriptionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSubscriptionRequest} createSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription: async (createSubscriptionRequest: CreateSubscriptionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSubscriptionRequest' is not null or undefined
            assertParamExists('createSubscription', 'createSubscriptionRequest', createSubscriptionRequest)
            const localVarPath = `/admin/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSubscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {string} actionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionActionByAdmin: async (subscriptionId: string, actionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('deleteSubscriptionActionByAdmin', 'subscriptionId', subscriptionId)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('deleteSubscriptionActionByAdmin', 'actionId', actionId)
            const localVarPath = `/admin/subscriptions/{subscriptionId}/actions/{actionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)))
                .replace(`{${"actionId"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPausedSubscriptions: async (date: string, page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('listPausedSubscriptions', 'date', date)
            const localVarPath = `/admin/subscriptions/paused`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptions: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listSubscriptions', 'userId', userId)
            const localVarPath = `/admin/users/{userId}/subscriptions`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {PauseSubscriptionRequest} pauseSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseSubscriptionByAdmin: async (subscriptionId: string, pauseSubscriptionRequest: PauseSubscriptionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('pauseSubscriptionByAdmin', 'subscriptionId', subscriptionId)
            // verify required parameter 'pauseSubscriptionRequest' is not null or undefined
            assertParamExists('pauseSubscriptionByAdmin', 'pauseSubscriptionRequest', pauseSubscriptionRequest)
            const localVarPath = `/admin/subscriptions/{subscriptionId}/pause`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pauseSubscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {DietaryTargetsRequest} dietaryTargetsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDietaryTargetsByAdmin: async (subscriptionId: string, dietaryTargetsRequest: DietaryTargetsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('updateDietaryTargetsByAdmin', 'subscriptionId', subscriptionId)
            // verify required parameter 'dietaryTargetsRequest' is not null or undefined
            assertParamExists('updateDietaryTargetsByAdmin', 'dietaryTargetsRequest', dietaryTargetsRequest)
            const localVarPath = `/admin/subscriptions/{subscriptionId}/dietary-targets`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dietaryTargetsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {UpdateSubscriptionRequest} updateSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription: async (subscriptionId: string, updateSubscriptionRequest: UpdateSubscriptionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('updateSubscription', 'subscriptionId', subscriptionId)
            // verify required parameter 'updateSubscriptionRequest' is not null or undefined
            assertParamExists('updateSubscription', 'updateSubscriptionRequest', updateSubscriptionRequest)
            const localVarPath = `/admin/subscriptions/{subscriptionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSubscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {string} actionId 
         * @param {UpdateSubscriptionActionRequest} updateSubscriptionActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionActionByAdmin: async (subscriptionId: string, actionId: string, updateSubscriptionActionRequest: UpdateSubscriptionActionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('updateSubscriptionActionByAdmin', 'subscriptionId', subscriptionId)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('updateSubscriptionActionByAdmin', 'actionId', actionId)
            // verify required parameter 'updateSubscriptionActionRequest' is not null or undefined
            assertParamExists('updateSubscriptionActionByAdmin', 'updateSubscriptionActionRequest', updateSubscriptionActionRequest)
            const localVarPath = `/admin/subscriptions/{subscriptionId}/actions/{actionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)))
                .replace(`{${"actionId"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSubscriptionActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSubscriptionControllerApi - functional programming interface
 * @export
 */
export const AdminSubscriptionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSubscriptionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} subscriptionId 
         * @param {AddPaymentRequest} addPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSubscriptionPayment(subscriptionId: string, addPaymentRequest: AddPaymentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSubscriptionPayment(subscriptionId, addPaymentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSubscription(subscriptionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSubscription(subscriptionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateSubscriptionRequest} createSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubscription(createSubscriptionRequest: CreateSubscriptionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSubscription(createSubscriptionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {string} actionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubscriptionActionByAdmin(subscriptionId: string, actionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSubscriptionActionByAdmin(subscriptionId, actionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPausedSubscriptions(date: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResponsePausedSubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPausedSubscriptions(date, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSubscriptions(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminSubscriptionDetailResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSubscriptions(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {PauseSubscriptionRequest} pauseSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pauseSubscriptionByAdmin(subscriptionId: string, pauseSubscriptionRequest: PauseSubscriptionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pauseSubscriptionByAdmin(subscriptionId, pauseSubscriptionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {DietaryTargetsRequest} dietaryTargetsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDietaryTargetsByAdmin(subscriptionId: string, dietaryTargetsRequest: DietaryTargetsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDietaryTargetsByAdmin(subscriptionId, dietaryTargetsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {UpdateSubscriptionRequest} updateSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubscription(subscriptionId: string, updateSubscriptionRequest: UpdateSubscriptionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubscription(subscriptionId, updateSubscriptionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {string} actionId 
         * @param {UpdateSubscriptionActionRequest} updateSubscriptionActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubscriptionActionByAdmin(subscriptionId: string, actionId: string, updateSubscriptionActionRequest: UpdateSubscriptionActionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubscriptionActionByAdmin(subscriptionId, actionId, updateSubscriptionActionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminSubscriptionControllerApi - factory interface
 * @export
 */
export const AdminSubscriptionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSubscriptionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} subscriptionId 
         * @param {AddPaymentRequest} addPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSubscriptionPayment(subscriptionId: string, addPaymentRequest: AddPaymentRequest, options?: any): AxiosPromise<void> {
            return localVarFp.addSubscriptionPayment(subscriptionId, addPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription(subscriptionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.cancelSubscription(subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSubscriptionRequest} createSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription(createSubscriptionRequest: CreateSubscriptionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createSubscription(createSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {string} actionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionActionByAdmin(subscriptionId: string, actionId: string, options?: any): AxiosPromise<SubscriptionDetailResponse> {
            return localVarFp.deleteSubscriptionActionByAdmin(subscriptionId, actionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPausedSubscriptions(date: string, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedResponsePausedSubscriptionResponse> {
            return localVarFp.listPausedSubscriptions(date, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptions(userId: string, options?: any): AxiosPromise<Array<AdminSubscriptionDetailResponse>> {
            return localVarFp.listSubscriptions(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {PauseSubscriptionRequest} pauseSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseSubscriptionByAdmin(subscriptionId: string, pauseSubscriptionRequest: PauseSubscriptionRequest, options?: any): AxiosPromise<SubscriptionDetailResponse> {
            return localVarFp.pauseSubscriptionByAdmin(subscriptionId, pauseSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {DietaryTargetsRequest} dietaryTargetsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDietaryTargetsByAdmin(subscriptionId: string, dietaryTargetsRequest: DietaryTargetsRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateDietaryTargetsByAdmin(subscriptionId, dietaryTargetsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {UpdateSubscriptionRequest} updateSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription(subscriptionId: string, updateSubscriptionRequest: UpdateSubscriptionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateSubscription(subscriptionId, updateSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {string} actionId 
         * @param {UpdateSubscriptionActionRequest} updateSubscriptionActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionActionByAdmin(subscriptionId: string, actionId: string, updateSubscriptionActionRequest: UpdateSubscriptionActionRequest, options?: any): AxiosPromise<SubscriptionDetailResponse> {
            return localVarFp.updateSubscriptionActionByAdmin(subscriptionId, actionId, updateSubscriptionActionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSubscriptionControllerApi - object-oriented interface
 * @export
 * @class AdminSubscriptionControllerApi
 * @extends {BaseAPI}
 */
export class AdminSubscriptionControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} subscriptionId 
     * @param {AddPaymentRequest} addPaymentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSubscriptionControllerApi
     */
    public addSubscriptionPayment(subscriptionId: string, addPaymentRequest: AddPaymentRequest, options?: AxiosRequestConfig) {
        return AdminSubscriptionControllerApiFp(this.configuration).addSubscriptionPayment(subscriptionId, addPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subscriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSubscriptionControllerApi
     */
    public cancelSubscription(subscriptionId: string, options?: AxiosRequestConfig) {
        return AdminSubscriptionControllerApiFp(this.configuration).cancelSubscription(subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSubscriptionRequest} createSubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSubscriptionControllerApi
     */
    public createSubscription(createSubscriptionRequest: CreateSubscriptionRequest, options?: AxiosRequestConfig) {
        return AdminSubscriptionControllerApiFp(this.configuration).createSubscription(createSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subscriptionId 
     * @param {string} actionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSubscriptionControllerApi
     */
    public deleteSubscriptionActionByAdmin(subscriptionId: string, actionId: string, options?: AxiosRequestConfig) {
        return AdminSubscriptionControllerApiFp(this.configuration).deleteSubscriptionActionByAdmin(subscriptionId, actionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSubscriptionControllerApi
     */
    public listPausedSubscriptions(date: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return AdminSubscriptionControllerApiFp(this.configuration).listPausedSubscriptions(date, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSubscriptionControllerApi
     */
    public listSubscriptions(userId: string, options?: AxiosRequestConfig) {
        return AdminSubscriptionControllerApiFp(this.configuration).listSubscriptions(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subscriptionId 
     * @param {PauseSubscriptionRequest} pauseSubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSubscriptionControllerApi
     */
    public pauseSubscriptionByAdmin(subscriptionId: string, pauseSubscriptionRequest: PauseSubscriptionRequest, options?: AxiosRequestConfig) {
        return AdminSubscriptionControllerApiFp(this.configuration).pauseSubscriptionByAdmin(subscriptionId, pauseSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subscriptionId 
     * @param {DietaryTargetsRequest} dietaryTargetsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSubscriptionControllerApi
     */
    public updateDietaryTargetsByAdmin(subscriptionId: string, dietaryTargetsRequest: DietaryTargetsRequest, options?: AxiosRequestConfig) {
        return AdminSubscriptionControllerApiFp(this.configuration).updateDietaryTargetsByAdmin(subscriptionId, dietaryTargetsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subscriptionId 
     * @param {UpdateSubscriptionRequest} updateSubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSubscriptionControllerApi
     */
    public updateSubscription(subscriptionId: string, updateSubscriptionRequest: UpdateSubscriptionRequest, options?: AxiosRequestConfig) {
        return AdminSubscriptionControllerApiFp(this.configuration).updateSubscription(subscriptionId, updateSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subscriptionId 
     * @param {string} actionId 
     * @param {UpdateSubscriptionActionRequest} updateSubscriptionActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSubscriptionControllerApi
     */
    public updateSubscriptionActionByAdmin(subscriptionId: string, actionId: string, updateSubscriptionActionRequest: UpdateSubscriptionActionRequest, options?: AxiosRequestConfig) {
        return AdminSubscriptionControllerApiFp(this.configuration).updateSubscriptionActionByAdmin(subscriptionId, actionId, updateSubscriptionActionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

